module.exports = __webpack_public_path__ + "media/images/ilustrations/ilustration-1-ba92486f14593bc0cbf8d24b89689b1d.png";